/**
 * Mail Support Utilities
 * Generates mailto links for support requests
 */

export const SUPPORT_EMAIL = 'support@elvoaq.com';

export const generateMailtoLink = (subject: string, body: string): string => {
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);
  return `mailto:${SUPPORT_EMAIL}?subject=${encodedSubject}&body=${encodedBody}`;
};

export const openMailClient = (subject: string, body: string): void => {
  const mailtoLink = generateMailtoLink(subject, body);
  window.location.href = mailtoLink;
};
